<template>
  <div class="reset_password_form_wrapper">
    <!-- Start:: Form Title -->
    <!-- <div class="form_title_wrapper">
    </div> -->
    <!-- End:: Form Title -->

    <!-- Start:: Form -->
    <div class="form_wrapper">
      <ValidationObserver v-slot="{ invalid }">
        <form class="mt-4" @submit.prevent="validateFormInputs">
          <div class="row justify-content-center">
            <!-- Start:: Password Input -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.password')"
              rules="required|custom_password"
              v-slot="{ errors }"
              class="col-7"
            >
              <base-input
                col="12"
                type="password"
                :placeholder="$t('PLACEHOLDERS.password')"
                v-model.trim="resetPasswordData.password"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>
            <!-- End:: Password Input -->

            <!-- Start:: Confirm Password Input -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.confirmPassword')"
              :rules="{
                required: true,
                password_match: { target: resetPasswordData.password },
              }"
              v-slot="{ errors }"
              class="col-7"
            >
              <base-input
                col="12"
                type="password"
                :placeholder="$t('PLACEHOLDERS.confirmPassword')"
                v-model.trim="resetPasswordData.confirmPassword"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>
            <!-- End:: Confirm Password Input -->

            <!-- Start:: Submit Button -->
            <div class="col-lg-7 my-5">
              <base-button
                class="mt-0 w-100"
                styleType="primary_btn"
                :btnText="$t('BUTTONS.confirm')"
                :isLoading="isWaitingRequest"
                :disabled="invalid || isWaitingRequest"
              />
            </div>
            <!-- End:: Submit Button -->
          </div>
        </form>
      </ValidationObserver>

      <!-- Start:: Login Route Wrapper -->
      <router-link to="/" class="register_route">
        <span>{{ $t("BUTTONS.haveAccount") }}</span>
        <span> {{ $t("BUTTONS.login") }}</span>
      </router-link>
      <!-- End:: Login Route Wrapper -->
    </div>
    <!-- End:: Form -->
  </div>
</template>

<script>
export default {
  name: "ResetPasswordForm",

  data() {
    return {
      // Start:: Loader Data
      isWaitingRequest: false,
      // End:: Loader Data

      // Start:: Data Collection To Send
      resetPasswordData: {
        password: null,
        confirmPassword: null,
      },
      passwordServerError: null,
      // End:: Data Collection To Send
    };
  },

  methods: {
    // Start:: Validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;

      if (!this.resetPasswordData.password) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.password"));
        return;
      } else if (this.resetPasswordData.password.length < 6) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.passwordLength"));
        return;
      } else if (!this.resetPasswordData.confirmPassword) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.password"));
        return;
      } else if (this.resetPasswordData.confirmPassword.length < 6) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.passwordLength"));
        return;
      } else if (
        this.resetPasswordData.password !=
        this.resetPasswordData.confirmPassword
      ) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.notEqualPasswords"));
        return;
      } else {
        this.submitForm();
      }
    },
    // End:: Validate Form Inputs

    // Start:: Set Server Error
    setServerError(field, error) {
      this[`${field}ServerError`] =
        error?.response?.data?.errors?.[field]?.[0] || null;
    },
    // End:: Set Server Error

    // Start:: Submit Form
    async submitForm() {
      this.isWaitingRequest = true;
      this.$axios.defaults.headers.common["Authorization"] =
        "Bearer " +
        localStorage.getItem("sakn_w_safar_admin_dashboard_forget_pass_token");

      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      REQUEST_DATA.append("password", this.resetPasswordData.password);
      REQUEST_DATA.append(
        "password_confirmation",
        this.resetPasswordData.confirmPassword
      );
      // End:: Append Request Data
      const token = localStorage.getItem(
        "sakn_w_safar_admin_dashboard_forget_pass_token"
      );
      try {
        await this.$axios({
          method: "POST",
          url: `auth/reset-password`,
          data: REQUEST_DATA,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.editedSuccessfully"));
        localStorage.removeItem(
          "sakn_w_safar_admin_dashboard_forget_pass_token"
        );
        localStorage.removeItem(
          "sakn_w_safar_admin_dashboard_reset_pass_token"
        );
        this.clearFormInputs();
        this.$router.replace("/");
      } catch (error) {
        this.isWaitingRequest = false;
        this.setServerError("password", error);
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form

    // Start:: Clear Form
    clearFormInputs() {
      this.resetPasswordData.password = null;
      this.resetPasswordData.confirmPassword = null;
    },
    // End:: Clear Form
  },
};
</script>
